import React from 'react';

export default function EmptyState({ title = 'No data found', text = 'Please add content from admin panel.' }) {
  return (
    <div style={{ padding: '32px 20px', textAlign: 'center', background: '#fff', border: '1px solid #edf0f7', borderRadius: 16 }}>
      <h4 style={{ marginBottom: 8 }}>{title}</h4>
      <p style={{ margin: 0, color: '#667085' }}>{text}</p>
    </div>
  );
}
